<template>
    <div class="detail_content">
			  <el-tabs v-model="activeName" @tab-click="handleClick">
			    <!-- <Nothing v-show="" ></Nothing> -->
			    <el-tab-pane label="目录" name="first">
			      <el-card shadow="always">
              <ul>
              	<li v-for="(item,index) in lessons" :key="index" class="detailkc_box">
              		<span class="detail-title"  href="javascript:;">
              			{{item.chapterName}}
              		</span>
                  <ul>
                     <li v-for="(i,index1) in item.books" :key="index1" class="detail_name" @click="toplayvideo(i,index,index1)">
                        <a class="" href="javascript:;">
                        	<img :src="imgurl(i.lessonType)" class="icon-video">
                        	<span class="kc-content-left-file-name">{{i.lessonName}}</span>
                        	<span class="kc-content-complete"><img src="../../../assets/img/icon-curriculum-complete.png" v-show="i.isOver == 2"></span>
                        </a>
                     </li>
                  </ul>
              	</li>
              </ul>
              <!-- <div class="noThing" v-show="lessons.length == 0">
                <img src="../../../assets/img/nothing.png" alt="">
                <p>暂无内容</p>
              </div> -->
              <Nothing v-show="lessons.length == 0" ></Nothing>
			      </el-card>
			    </el-tab-pane>
			    <el-tab-pane label="简介" name="second">
			      <!-- <Nothing v-show="" ></Nothing> -->
			      <el-card shadow="always">
              <div v-html="content"></div>
              <!-- <div class="noThing" v-show="content.length == 0">
                <img src="../../../assets/img/nothing.png" alt="">
                <p>暂无内容</p>
              </div> -->
              <Nothing v-show="content.length == 0" ></Nothing>
			      </el-card>
			    </el-tab-pane>

       <!--   <el-tab-pane label="练习" name="third">
            <el-card shadow="always">
              <div v-if="practice" class="practice" href="javascript:;" @click="topractice(practice.practiceId)">
                <span class="kc-content-left-file-name">{{practice.practiceName}}</span>
                <span class="kc-content-complete">{{practice.rate + '%'}}</span>
              </div>
              <Nothing v-else ></Nothing>
            </el-card>
          </el-tab-pane> -->
			  </el-tabs>
    </div>
</template>

<script>
import Nothing from '../../Nothing/Nothing.vue'
import {ApiGetBookchapter,ApiGetlessonStatus,ApiGetpractice} from '../../../net/course/index.js'
import {ApiSaveCourseProcess} from '../../../net/accound/index.js'
import {setCookie} from '../../../untils/common.js'
export default {
  props: {
    content: {
      type: String ,
      default : ''
    }
  },
  data: function () {
    return {
      activeName : 'first',
      lessons : [],
      imgurl2 :require('../../../assets/img/icon-curriculum-video.png'),
      imgurl3 :require('../../../assets/img/icon-curriculum-audio.png'),
      imgurl1 :require('../../../assets/img/icon-curriculum-data.png'),
      courseId : null,
      practice : null
    }
  },
  computed: {
    imgurl() {
      var self =this;
      return function(type){
        if(type == 1){
          return self.imgurl1
        }else if (type == 2){
          return self.imgurl2
        }else{
          return self.imgurl3
        }
      }
    }
  },
  methods:{
    toplayvideo(i,index,index1){
      // if(index == 0){//先判断章节
      //   if(index1 != 0){
      //       if(this.lessons[index].lessons[index1-1].isOver==2){
      //         // return true
      //       }else{
      //         this.$message.error('请先学习上一课程')
      //         return false
      //       }
      //   }
      // }else{
      //   if(index1 == 0 ){
      //     const len = this.lessons[index - 1].lessons.length;
      //     if(this.lessons[index - 1].lessons[len-1].isOver != 2){
      //       this.$message.error('请先学习上一课程')
      //       return false
      //     }
      //   }else{
      //     if(this.lessons[index].lessons[index1-1].isOver != 2){
      //       this.$message.error('请先学习上一课程')
      //       return false
      //     }
      //   }
      // }
      const params = {
        lessonId : i.lessonId
      }
      ApiGetlessonStatus(params).then(res=>{
        if(res.code == 200){
          if(res.value){
            this.lessonStatu(i)
          }else{
            this.$message.error('请先学习上一课程')
          }
        }
      })
    },
    lessonStatu(i){
      if(i.lessonType == 2 || i.lessonType == 3){
        const { href } = this.$router.resolve({
              path: `Player`,
              query:{lid : i.lessonId}
            });
            window.open(href, '_blank');
      }else{
        const param = {
          lessonId : i.lessonId,
          courseId : this.courseId,
          process : 100,
          isOver : 2,
          total : 100,
          source : 'pc'
        }
        ApiSaveCourseProcess(param).then(res=>{

        }).catch(err=>{

        })
        setCookie('pdfurl', i.playUrl)
        const { href } = this.$router.resolve({
              path: 'PdfShow',
            });
            window.open(href, '_blank');
      }
    },
    handleClick(){

    },
    topractice(item){
      this.$router.push({          path: '/Exercise',          query: {eid: item}        })
    },
    getchapter(){
      const param = {
        id : this.$route.query.id,
        pageNum : 1,
        pageSize : 100,
        platform : 'pc'
      }
      ApiGetBookchapter(param).then(res=>{
        // console.log(res)
        if(res.code == 200){
          this.lessons = res.value;
        }
      })
    },
    getpractice(){
      const param = {
        courseId : this.$route.query.id
      }
      ApiGetpractice(param).then(res=>{
        if(res.code == 200){
          if(res.value){
            this.practice = res.value
          }else{
            this.practice = null
          }

        }
      })
    }
  },
  components:{
    Nothing
  },
  mounted() {
    this.courseId = this.$route.query.id;
    this.getchapter();
    this.getpractice();
  }
}
</script>

<style>
  .detail_content .el-card{
    border: 0;
  }
  .detail_content .el-card__body{
    padding: 0;
  }
  .detail_content .el-tabs__item{
    font-size: 18px;
  }
  .detail_content .el-tabs__active-bar{
    width: 35px;
  }
  .detail_content .detailkc_box{
    list-style-type: none;
    margin-right: 20px;
    padding-top: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e5e5e5;
  }
  .detail_content .detail-title{
    width: 692px;
    font-size: 16px;
    color: #7f7f7f;
    border-radius: 6px;
    overflow: hidden;
    line-height: 32px;
  }
  .detail_content .detail_name{
    overflow: hidden;
    width: 712px;
    margin-top: 10px;
  }
  .noThing{
    width: 100%;
    height: 272px;
    text-align: center;
  }
  .noThing img{
    width: 200px;
    margin-top: 50px;
  }
  .noThing p {
    margin-top: 20px;
    font-size: 20px;
  }
  .kc-content-left-file-name:hover{
    color: #0AAC50;
  }
  .practice{
    margin-top: 20px;
  }
  .practice:hover{
    cursor: pointer;
  }
  .practice .kc-content-complete{
    color: green;
  }
</style>



// WEBPACK FOOTER //
// src/components/BookCourseDetail/child/Detailcontent.vue